"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDivider = exports.StyledIcon = exports.StyledSectionLabel = exports.StyledContentPanel = exports.StyledPaletteColorWrapper = exports.StyledPalette = exports.StyledColorPanelContent = exports.StyledColorPanel = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledColorPanel = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
  overflow-y: auto;
  ${({ theme }) => theme.Scrollbar.Panel}
`;
exports.StyledColorPanelContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
exports.StyledPalette = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};

  ${({ variant }) => variant === 'circle' &&
    (0, styled_components_1.css) `
      align-items: center;
      flex-direction: column-reverse;
    `}
`;
exports.StyledPaletteColorWrapper = styled_components_1.default.div `
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: center;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Small)};
  overflow: hidden;
`;
exports.StyledContentPanel = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
  width: 100%;

  ${({ variant }) => {
    if (variant === 'group') {
        return (0, styled_components_1.css) `
      flex
        padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
      `;
    }
    return (0, styled_components_1.css) ``;
}}
`;
exports.StyledSectionLabel = styled_components_1.default.div `
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledIcon = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.StyledDivider = styled_components_1.default.hr `
  width: 100%;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  margin: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)} 0;
`;
//# sourceMappingURL=Color.style.js.map